module.exports = __webpack_public_path__ + "static/dm-banner-image-57731224760c32638dfcac689c1d6487.png";